<template>
  <v-select v-model="selectedTriggerEndpoints" :filled="!solo" :solo="solo" :hide-details="!solo" :single-line="solo" :multiple="multiple"
    :items="triggerList" :rules="rules" :label="label" :clearable="clearable" prepend-inner-icon="mdi-signal-variant">
    <template v-slot:item="{ item, attrs }">
      <v-list-item-avatar tile>
        <span class="font-weight-bold" v-if="item.value=='onboard-air-sensor-co2'">CO<sub>2</sub></span>
        <span class="font-weight-bold" v-else-if="item.value=='onboard-air-sensor-co'">CO</span>
        <span class="font-weight-bold" v-else-if="item.value=='onboard-air-sensor-voc'">VOC</span>
        <v-icon class="primary--text" v-else>{{ trigger[item.value].icon }}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title :class="attrs.inputValue?'primary--text':'black--text'">{{item.text}}</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action :class="attrs.inputValue?'primary--text':'grey--text'">{{$t(`type.${trigger[item.value].type}`)}}</v-list-item-action>
    </template>
  </v-select>
</template>
<script>
export default {
  name: 'TriggerEndpointSelector',
  props: {
    value: {
      type: Array,
    },
    rules: {
      type: Array
    },
    label: {
      type: String
    },
    solo: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    availableEndpoints: {
      type: Array
    },
    config: {
      type: Object
    }
  },
  data() {
    return {
      trigger: {
        "external-light-1": {type: 'LIGHT', icon: 'mdi-lightbulb'},
        "onboard-sensor-temperature": {type: 'TEMPERATURE', icon: 'mdi-thermometer'},
        "onboard-sensor-humidity": {type: 'HUMIDITY', icon: 'mdi-lightbulb'},
        "onboard-sensor-illumination": {type: 'ILLUMINATION', icon: 'mdi-brightness-6'},
        "onboard-air-sensor-co2": {type: 'CONCENTRATION', icon: 'co2'},
        "onboard-air-sensor-co": {type: 'CONCENTRATION', icon: 'co'},
        "onboard-air-sensor-voc": {type: 'CONCENTRATION', icon: 'voc'},
        "onboard-sensor-motion": {type: 'MOTION', icon: 'mdi-motion-sensor'},
        "onboard-sensor-smoke": {type: 'SMOKE', icon: 'mdi-smoke-detector'},
        "smart-button-3": {type: 'BUTTON', icon: 'mdi-gesture-tap'}
      }
    }
  },
  computed: {
    selectedTriggerEndpoints: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    triggerList() {
      let list = Object.keys(this.trigger);
      return list.map(id => ({
        text: (this.config || {})[id] ? this.config[id].name : this.$t(`type.${this.trigger[id].type}`),
        value: id
      }))
    }
  }
}
</script>